import React from 'react';
import './About.css';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="about" id="about">
      <div className="about-container">
        <div className="about-title-container">
          <h2 className="about-title">
            {t('about.title')} <span className="highlight">{t('about.highlight')}</span>
          </h2>
        </div>
        <div className="about-description-wrapper">
          <div className="about-description-container">
            <p className="about-description">
              {t('about.description')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 